module.exports = __webpack_public_path__ + "media/images/default-avatar-7a74139a.png";